import BoxWithLightGreyFill from 'components/common/Box/BoxWithLightGreyFill';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { convertMicroCost } from 'utils/cost/convertMicroCost';

interface ITotalCostSection {
  subscriptionEnabled: boolean;
}

export const TotalCostSection = observer(
  ({ subscriptionEnabled }: ITotalCostSection) => {
    const { orderCost, isReferralFlow, currentPromo } = useEnterStore();
    const [showDiscountedCost, setShowDiscountedCost] = useState(false);

    useEffect(() => {
      (async () => {
        if (orderCost.price !== orderCost.cost) {
          setShowDiscountedCost(true);
        } else {
          setShowDiscountedCost(false);
        }
      })();
    }, [orderCost.price, orderCost.cost]);

    const renderSubscribeMessage = () => {
      if (
        orderCost.price !== orderCost.cost &&
        !isReferralFlow &&
        orderCost.discount !== 0 &&
        currentPromo
      ) {
        return (
          <>
            <span
              style={{
                marginRight: 5,
              }}
            >
              This week
            </span>
            <span
              className="uppercase px-2 rounded-full text-sm"
              style={{
                verticalAlign: 'middle',
                fontSize: 9,
                textTransform: 'initial',
                display: 'inline-block',
                textAlign: 'start',
                background: '#5affda',
              }}
            >
              {currentPromo.banner}
            </span>
          </>
        );
      }
      return 'This Week';
    };

    return (
      <BoxWithLightGreyFill style={{ background: '#E1E1E1' }}>
        <div className="grid gap-1em">
          <div className={'flexSpaceBetween'}>
            <div>
              <p className={'text-base md:text-lg xbold'}>
                {subscriptionEnabled ? 'Weekly subscription' : 'Total'}
              </p>
            </div>
            <div className="flexRow">
              <p className="text-base md:text-lg noMargin">
                £{convertMicroCost(orderCost.price)}
              </p>

              {subscriptionEnabled && (
                <p className="text-base md:text-lg noMargin">&nbsp;/ week</p>
              )}
            </div>
          </div>

          {showDiscountedCost && (
            <div className={`flexSpaceBetween`}>
              <div>
                <p className="text-base md:text-lg xbold">
                  {renderSubscribeMessage()}
                </p>
              </div>

              <div className="flex gap-2">
                <p className="text-base md:text-lg noMargin line-through">
                  £{convertMicroCost(orderCost.price)}
                </p>
                <p className="text-base md:text-lg noMargin">
                  £{convertMicroCost(orderCost.cost)}
                </p>
              </div>
            </div>
          )}
        </div>
      </BoxWithLightGreyFill>
    );
  }
);
